angular.module('impactx.dashboard').controller('AddFullWidthGridCtrl', [
    '$scope',
    '$mdDialog',
    'TranslationService',
    AddFullWidthGridCtrl]);

function AddFullWidthGridCtrl($scope, $mdDialog, TranslationService) {
    $scope.abortLabel = TranslationService.get("abort");
    $scope.confirmLabel = TranslationService.get("accept");
    $scope.errorList = [];

    var selectedWidth = null;
    var selectedHeight = null;

    var self = this;

    this.cancel = function () {
        $mdDialog.cancel();
    };

    this.answer = function () {
        $mdDialog.hide($scope.setAvailablePanel);
    };

    this.checkForErrors = function () {
        $scope.errorList.length = 0;
        if (!$scope.setAvailablePanel) {
            $scope.errorList.push(self.trns.chooseOnePanel);
        }
    };

    self.checkForErrors();
}